import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    DeleteCcReviewReviewItem,
    setCcReviewReviewShowConfirmDelete,
    setCcReviewReviewReloadList,
} from "client/store"
import {
    ConfirmWrapper,
    Confirm,
    ConfirmTitle,
    ConfirmDescription,
    ConfirmBottom,
    Button,
    SpinnerIcon,
} from "client/components"

const ConfirmDelete = () => {
    const activeItem = useSelector((state: StoreType) => state.ccReviewReview.active)
    const showConfirm = useSelector((state: StoreType) => state.ccReviewReview.showConfirmDelete)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [deleteState, setDeleteState] = useState<StateType>(IDLE)

    const onCancel = () => {
        dispatch(setCcReviewReviewShowConfirmDelete(false))
    }

    const onConfirm = () => {
        setDeleteState(PENDING)
        DeleteCcReviewReviewItem(activeItem.id).then(() => {
            setDeleteState(IDLE)
            dispatch(setCcReviewReviewShowConfirmDelete(false))

            dispatch(setCcReviewReviewReloadList(false))
            setTimeout(() => {
                dispatch(setCcReviewReviewReloadList(true))
            }, 0)
        })
    }

    return (
        <ConfirmWrapper show={showConfirm} onClose={onCancel}>
            <Confirm>
                <ConfirmTitle>{activeItem && activeItem.remark}</ConfirmTitle>
                <ConfirmDescription>{lang.deleteItemConfirm}</ConfirmDescription>

                <ConfirmBottom>
                    <Button row onClick={onCancel}>{lang.cancel}</Button>
                    <Button variant="success" row onClick={onConfirm}>
                        {deleteState === PENDING ? <SpinnerIcon /> : lang.confirm}
                    </Button>
                </ConfirmBottom>
            </Confirm>
        </ConfirmWrapper>
    )
}
export default ConfirmDelete
